import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  margin: 10px 0px;
`

export const Fields = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`

export const Domains = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`
